import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/core-api/services/auth/auth.service';
import { PlatformService } from 'src/app/core-api/platform/platform.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private _authService: AuthService,
        private _router: Router,
        private platformService: PlatformService,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let newReq = req.clone();
        const authSession = this._authService.AuthSession;

        if (!!authSession) {
            //if (!AuthUtils.isTokenExpired(authSession.AccessToken)) {
                newReq = req.clone({
                    headers: req.headers
                    .set('Authorization', 'Bearer ' + authSession.AccessToken)
                    .set('SOCIETE_ID', authSession.User.SOCIETE_ID)
                    .set('USER_ID', authSession.User.ID)
                });
            //} 
        }
        if (this.platformService.isAndroidApp()) {
            newReq = newReq.clone({
                headers: newReq.headers.set('X-ABW-ANDROID-ID', this.platformService.deviceId())
            });
        }

        return next.handle(newReq).pipe(
            catchError((error) => {
                if ( error instanceof HttpErrorResponse && error.status === 401 && error.url!.lastIndexOf('/api/Auth/RefreshToken') === -1) {
                    this._authService.doSignOutAction();
                    this._router.navigateByUrl('/login');
                }
                if ( error instanceof HttpErrorResponse && error.status === 400) {
                    if (!!error.error.InternalErrorCode) {
                        const internalErrorCore = error.error.InternalErrorCode;
                        switch(internalErrorCore) {
                            case 'MOBILE_NOT_UPDATED':
                                this._authService.doSignOutAction();
                                this._router.navigateByUrl('/updates');
                                break;
                                
                            case 'APP_NOT_UPDATED':
                                this._authService.doSignOutAction();
                                this._router.navigateByUrl('/updates');
                                break;
                        }
                    }
                }
                return throwError(error);
            })
        );
    }
}
